// Pointer-following loading spinner shown during cross-document navigations.
// Intercepts same-origin link clicks, adds `.is-loading` to <html>, and lets
// the browser handle the actual navigation. The new page renders without the
// class, so the spinner disappears naturally.

const OFFSET_X = 22;
const OFFSET_Y = 18;

export default function initLoader() {
  let loader = document.querySelector('.cursor-loader');
  if (!loader) {
    loader = document.createElement('div');
    loader.className = 'cursor-loader';
    loader.setAttribute('aria-hidden', 'true');
    loader.innerHTML = `
      <svg viewBox="0 0 24 24" role="presentation">
        <circle cx="12" cy="12" r="10" fill="none" stroke="rgba(0,0,0,0.18)" stroke-width="2" />
        <circle cx="12" cy="12" r="10" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-dasharray="35 65" pathLength="100" />
      </svg>
    `;
    document.body.appendChild(loader);
  }

  const moveTo = (x, y) => {
    loader.style.transform = `translate3d(${x + OFFSET_X}px, ${y + OFFSET_Y}px, 0)`;
  };

  document.addEventListener('pointermove', (e) => {
    moveTo(e.clientX, e.clientY);
  }, { passive: true });

  document.addEventListener('click', (e) => {
    const anchor = e.target.closest('a[href]');
    if (!anchor) return;

    // Modifier / middle-click → browser opens in new tab. Don't show loader.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

    if (anchor.target && anchor.target !== '_self') return;
    if (anchor.hasAttribute('download')) return;

    // Intra-document panel triggers (litigation cards) are AJAX — skip loader.
    if (anchor.hasAttribute('data-panel')) return;

    let url;
    try { url = new URL(anchor.href, location.href); } catch { return; }

    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname
        && url.search === location.search
        && url.hash !== '') return;

    // Place loader at the click point in case no pointermove has fired yet
    // (keyboard-activated link, synthesized click, etc.).
    moveTo(e.clientX, e.clientY);
    document.documentElement.classList.add('is-loading');
  });

  // bfcache restore (back/forward): clear stale loader state.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      document.documentElement.classList.remove('is-loading');
    }
  });
}
